import React from 'react';
import { Show, TextField, DateField } from 'react-admin';
import { LinkField, JsonTextField } from '../../components/fields';
import { GridShowLayout, Grid } from '../../components/wrapper';
import ApprovableAdminActionShowActions from './ApprovableAdminActionShowActions';

const ApprovableAdminActionShow = props => (
	<Show {...props} actions={<ApprovableAdminActionShowActions />}>
		<GridShowLayout>
			<Grid container>
				<Grid item sm={12} md={6}>
					<TextField source="id" />
					<DateField source="creationDateTime" showTime />
					<LinkField source="initiator" />
					<div></div>
				</Grid>
				<Grid item sm={12} md={6}>
					<TextField source="status" />
					<DateField source="finalizeDateTime" showTime />
					<LinkField source="finalizer" />
					<TextField source="error" />
				</Grid>
				<Grid item xs={12} md={6}>
					<JsonTextField source="request" />
				</Grid>
				<Grid item xs={12} md={6}>
					<JsonTextField source="response" />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default ApprovableAdminActionShow;
